import template from './template.html';

controller.$inject = ['adalAuthenticationService', '$state', 'AuditService'];

export function controller(adalAuthenticationService, $state, AuditService) {
    const user = adalAuthenticationService.userInfo;
    if (user && user.isAuthenticated) {
        AuditService.auditLogon(user.userName);
        $state.go('storeselector');
    }
}

config.$inject = ['$stateProvider'];

function config($stateProvider) {
    $stateProvider.state('landing', {
        controller: controller,
        controllerAs: 'vm',
        parent: 'guest',
        template: template,
        url: ''
    });
}

export default config;



// WEBPACK FOOTER //
// ./src/js/components/guest/landing/index.js